<template>
  <pt-business-order-lot-new class="pt-business-order-lot-new__withData"></pt-business-order-lot-new>
</template>

<script>
import PtBusinessOrderLotNew from './index'
export default {
  name: 'pt-business-order-lot-new__withData',
  components: {
    'pt-business-order-lot-new': PtBusinessOrderLotNew
  }
}
</script>
